import React from "react";
import { Link } from "react-router-dom";
import {
  BsArrowUpRight,
  BsEnvelope,
  BsGeoAlt,
  BsTelephone,
  BsWhatsapp,
} from "react-icons/bs";

const footerLinkClass =
  "text-sm text-gray-400 transition-colors hover:text-[#c49a8c]";

const Footer = ({ isLogin, setLoginModal }) => {
  const openAccountPage = () => setLoginModal(true);

  return (
    <footer className="bg-[#171815] text-white">
      <div className="site-container py-12 lg:py-16">
        <div className="grid grid-cols-1 gap-10 border-b border-white/10 pb-12 sm:grid-cols-2 lg:grid-cols-[1.5fr_0.8fr_0.9fr_1.35fr] lg:gap-12">
          <div className="max-w-md">
            <Link to="/" aria-label="Fina Interiors home" className="inline-block">
              <img
                src="/logo.png"
                alt="Fina Interiors"
                className="h-20 w-auto object-contain"
              />
            </Link>
            <p className="mt-5 text-base font-semibold text-white">
              Thoughtful spaces. Beautifully lived in.
            </p>
            <p className="mt-3 max-w-sm text-sm leading-6 text-gray-400">
              Fina Interiors brings design, furniture and coordinated execution
              together to create refined homes shaped around everyday life.
            </p>
            <Link
              to="/about-us"
              className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#c49a8c] hover:text-white"
            >
              About Fina Interiors <BsArrowUpRight aria-hidden="true" />
            </Link>
          </div>

          <div>
            <h2 className="text-sm font-semibold uppercase text-white">Company</h2>
            <ul className="mt-5 space-y-3">
              <li><Link to="/about-us" className={footerLinkClass}>About us</Link></li>
              <li><Link to="/contact-us" className={footerLinkClass}>Contact us</Link></li>
              <li><Link to="/blogs" className={footerLinkClass}>Journal</Link></li>
              <li><Link to="/privacy-policy" className={footerLinkClass}>Privacy policy</Link></li>
              <li><Link to="/terms-and-condition" className={footerLinkClass}>Terms &amp; conditions</Link></li>
              <li><Link to="/shipping-policy" className={footerLinkClass}>Shipping policy</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold uppercase text-white">Explore</h2>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/fina-interiors-home-interior-services" className={footerLinkClass}>
                  Interior services
                </Link>
              </li>
              <li><Link to="/get-quote" className={footerLinkClass}>Request a quote</Link></li>
              <li>
                {isLogin ? (
                  <Link to="/dashboard" className={footerLinkClass}>My account</Link>
                ) : (
                  <button type="button" onClick={openAccountPage} className={footerLinkClass}>My account</button>
                )}
              </li>
              <li>
                {isLogin ? (
                  <Link to="/recent-orders" className={footerLinkClass}>Recent orders</Link>
                ) : (
                  <button type="button" onClick={openAccountPage} className={footerLinkClass}>Recent orders</button>
                )}
              </li>
              <li>
                <Link to="/Sales-Service-Task-Force" className={footerLinkClass}>
                  Sales service task force
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold uppercase text-white">Visit or contact</h2>
            <address className="mt-5 space-y-4 not-italic">
              <div className="flex gap-3">
                <BsGeoAlt className="mt-1 shrink-0 text-[#858653]" size={18} aria-hidden="true" />
                <p className="text-sm leading-6 text-gray-400">
                  Shop No. 1, Apartment, Mohammed Wadi Rd, near Desai Hospital,
                  opposite Margosa Heights, Autadwadi Handewadi, Hadapsar, Pune,
                  Maharashtra 411060
                </p>
              </div>
              <a href="tel:+919112881916" className="flex items-center gap-3 text-sm text-gray-300 hover:text-white">
                <BsTelephone className="shrink-0 text-[#858653]" size={18} aria-hidden="true" />
                +91 91128 81916
              </a>
              <a href="mailto:finainterior29@gmail.com" className="flex items-center gap-3 break-all text-sm text-gray-300 hover:text-white">
                <BsEnvelope className="shrink-0 text-[#858653]" size={18} aria-hidden="true" />
                finainterior29@gmail.com
              </a>
            </address>
            <a
              href="https://wa.me/919112881916?text=Hi%20Fina%20Interiors%2C%20I%20would%20like%20to%20discuss%20my%20interior%20project."
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 bg-[#858653] px-5 py-3 text-sm font-semibold text-white hover:bg-[#747548]"
            >
              <BsWhatsapp size={17} aria-hidden="true" />
              Start on WhatsApp
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-6 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between">
          <p>Copyright &copy; {new Date().getFullYear()} Fina Interiors. All rights reserved.</p>
          <p>Interior design and furniture in Pune, Maharashtra.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
